import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=0f03717a&scoped=true&lang=pug&"
import script from "./CreateNew.vue?vue&type=script&lang=js&"
export * from "./CreateNew.vue?vue&type=script&lang=js&"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=0f03717a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03717a",
  null
  
)

export default component.exports